import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { FaTwitter, FaInstagram } from 'react-icons/fa';

export const Footer = () => {
    const currentYear = new Date().getFullYear();
  
    return (
      <Box component="footer" sx={{ textAlign: 'center', py: 3, px: 2, mt: 'auto', backgroundColor: 'background.paper' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          &copy; {currentYear} TrackCoPR. All rights reserved. | No Ads, No Trackers. |{' '}
          <MuiLink component={Link} to="/privacy-policy" color="inherit" underline="hover">
            Privacy Policy
          </MuiLink>
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Official Info:{' '}
          <MuiLink
            href="https://www.canada.ca/en/immigration-refugees-citizenship.html"
            target="_blank"
            rel="noopener"
            color="inherit"
            underline="hover"
          >
            IRCC Website
          </MuiLink>
          {' | '} Contact:{' '}
          <MuiLink href="mailto:admin@trackcopr.com" color="inherit" underline="hover">
            admin@trackcopr.com
          </MuiLink>
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
          Disclaimer: Not affiliated with the Government of Canada. Info is for educational purposes only, not legal advice. Use responsibly.
        </Typography>
        {/* Social Media Links */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 2 }}> {/* Removed explicit font size */}
          <MuiLink href="https://x.com/trackcopr" target="_blank" rel="noopener noreferrer" aria-label="Twitter" sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}>
            <FaTwitter size="1.25rem" /> {/* Control size via prop */}
          </MuiLink>
          <MuiLink href="https://www.instagram.com/trackcopr_com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}>
            <FaInstagram size="1.25rem" /> {/* Control size via prop */}
          </MuiLink>
        </Box>
      </Box>
    );
  };

